export const calculateBytesFromMB = (sizeInMB: number): number => {
  return sizeInMB * 1024 * 1024;
}
